/**
 * Opens WhatsApp (the app, or WhatsApp Web) with the message typed in and the
 * chat open on the number — or on a contact picker when there is no number.
 * Nothing is sent until the person presses send in WhatsApp itself.
 */
export function openWhatsApp(phone, text, win) {
  const url = `https://wa.me/${phone || ''}?text=${encodeURIComponent(text)}`;
  if (win && !win.closed) { win.location.href = url; return; }
  window.open(url, '_blank', 'noopener');
}

/**
 * A window opened in the click itself, before any await: a window opened after
 * a server round trip counts as a pop-up and is blocked.
 */
export function preopenWindow() {
  const win = window.open('', '_blank');
  if (win) win.opener = null;
  return win;
}
